import type { HelpFile } from '../../types/help'
import { ApprovalChainTestIds } from '../../../testids/ApprovalChainTestIds'

export const approvalChainHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalChainTestIds.approverConnectorIntermediate]: null,
    [ApprovalChainTestIds.approverConnectorLast]: null,
    [ApprovalChainTestIds.btnApprove]: 'Diesen Schritt genehmigen und den Antrag zum nächsten Genehmiger weiterleiten.',
    [ApprovalChainTestIds.btnReject]: 'Antrag ablehnen — weitere Genehmigungen entfallen, der Antragsteller wird benachrichtigt.',
  },
}
